import store from '@/store'
import firebase from 'firebase'
import lockr from 'lockr'
require('firebase/firestore')
const db = firebase.firestore()
let unsubscribe

firebase.auth().onAuthStateChanged(function (user) {
  // @TODO Add a logout message
  if (user) {
    unsubscribe = db.collection('checklist').where('user', '==', user.uid).onSnapshot((snap) => {
      let data = null
      snap.docChanges.forEach((change) => {
        data = change.doc.data()
      })
      store.commit('setChecklist', data)
      store.commit('filterResources')
    })
  } else {
    if (typeof unsubscribe === 'function') {
      let intakeData = lockr.get('intakeData')

      unsubscribe()
      unsubscribe = null

      if (store.state.user.uid && intakeData) {
        lockr.set('intakeData', intakeData)
        store.commit('setChecklist', {data: intakeData})
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/checklist.js